module.exports = __webpack_public_path__ + "static/img/sy.0d472042.png";